import { render, staticRenderFns } from "./DeleteActionIcon.vue?vue&type=template&id=73a60519&"
import script from "./DeleteActionIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteActionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports